<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Jobs Table
                </b-card-title>
            </b-card-header>
        </b-card>

        <b-tabs pills class="tab-jobs-garden-help mt-3" v-model="tabIndex" @input="changeTab" >
            <b-tab title="Requests" lazy>
                <JobsTable type="offers" title="Offers"/> 
                <JobsTable type="requests" title="Jobs requests"/>
            </b-tab>
            <b-tab title="In progress"  lazy>               
                 <JobsTable type="current" title="Jobs in progress"/>

                </b-tab>
            <b-tab title="Archived" lazy>
                <JobsTable type="history" title="Archived Jobs"/>
  </b-tab>
        </b-tabs>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";

import JobsTable from "./JobsTable.vue";

export default {
    name: "GardenHelpJobsTable",
    components: { JobsTable },
    data() {
        return {
            client_name: "GARDENHELP",
            tabIndex: 0
        }
    },
    methods: {
        changeTab(tabIndex) {
            console.log("change tab", tabIndex)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/jobs_table/Index.vue